module.exports = __webpack_public_path__ + "static/img/banner1@2x.45153a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopIntr/shop/banner1@2x.png
// module id = EICe
// module chunks = 18